import React, {PropTypes} from 'react';
import { FormGroup, ControlLabel, Button, Row, Col, Modal, HelpBlock } from 'react-bootstrap';
import Classnames from 'classnames';
// SHARED
import { FieldGroup } from '../core/components/FieldGroup';

export default class CancelReactivateSubscriptionModal extends React.Component {

  constructor(props){
    super(props)

    this.state = this.initialState()
  }

  initialState() {
    return {
      password: ""
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { productIdentifier } = this.props

    this.props.onCancelReactivateSubscriptionSubmit(this.state.password)

    // Reset component state
    this.setState(this.initialState());
  }

  handleChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  }


  render() {
    const form = this.props.form;
    const { showModal, modalTitle, total, interval, onCancel } = this.props

    const verifyPasswordClass = Classnames({
      "display-none": !this.props.verifyPassword
    })

    const submitBtnClass = Classnames({
      "submitting": form.submitting,
      "btn-main-blue": !form.success,
      "btn-main-green": form.success
    })

    const circleStyle = {
      strokeDasharray: "240px, 240px",
      strokeDashoffset: "480px"
    };
    const pathStyle = {
      strokeDasharray:"50px, 50px",
      strokeDashoffset: "0px"
    }
    const fullWidth = {
        width: "100% ",
        textAlign: "center",
    }
    const errorsBox = {
        width: "100% ",
        textAlign: "center",
        color: "#d02f2f",
        marginTop: "15px"
    }
    const btnInlineStyle =   {
        width: "100%",
        height: "45px",
        fontSize: "18px"
    }

    const checkmark = (<span className="icon icon--order-success inlinesvg svg">
      <svg width="26px" height="26px">
        <g fill="none" stroke="#FFFFFF" stroke-width="2">
          <circle cx="13" cy="13" r="12" style={circleStyle}></circle>
          {/*<path d="M19.417,37.778l9.93,9.909l20.444-22.393" style={pathStyle}></path>*/}
          <path d="M5.817,13.778l4.93,4.909l9.444-11.393" style={pathStyle}></path>
        </g>
      </svg>
    </span>)

    var buttonContent;
    if (form.success) {
      buttonContent = checkmark
    } else {
      buttonContent = form.submitting ? this.props.buttonTitleSubmitting : this.props.buttonTitle
    }

    var errorMessage;
    if (form.error) {
      errorMessage = form.error_message;
    } else {
      errorMessage = null;
    }

    return (
      <div className="subscription-form-box">
        <Modal bsSize="small" show={showModal} onHide={onCancel} dialogClassName="custom-modal" >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={ this.handleSubmit.bind(this) }>
              <Row className={verifyPasswordClass}>
                <Col xs={ 12 } sm={ 12 }>
                  <FieldGroup
                    id="verify-password"
                    type="password"
                    label="Current Password"
                    placeholder=""
                    name="password"
                    value={this.state.password}
                    onChange={this.handleChange.bind(this)}
                    help="Your subscription will cancel at the end of the current period."
                  />
                </Col>
              </Row>
              <div className="full-width-center-text" style={fullWidth}>
                <Button disabled={form.submitting || form.success} className={submitBtnClass} style={btnInlineStyle} type="submit">
                  {buttonContent}
                </Button>
              </div>
              <div style={errorsBox}>
                {errorMessage}
              </div>

            </form>
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

CancelReactivateSubscriptionModal.propTypes = {
};



// WEBPACK FOOTER //
// ./src/subscriptions/CancelReactivateSubscriptionModal.js